document.addEventListener('DOMContentLoaded', function() {
  const form = document.querySelector('form');
  const companyNameInput = document.getElementById('company_name');
  const errorMessage = document.getElementById('company_name_error');


  form.addEventListener('submit', function(event) {
    const companyName = companyNameInput.value.toLowerCase();
    if (companyName.includes('nowlun')) {
      event.preventDefault();
      errorMessage.textContent = "Company name cannot include 'nowlun'";
    }
  });
});